<template>
  <div>
    <transition name="slide-fade">
      <div class="alert alert-danger" v-if="hasErrors">
        <ul>
          <li v-for="error in serverErrors">{{ error }}</li>
        </ul>
      </div>
    </transition>

    <div class="form-group form-group-default required">
      <label>{{ $t("models.user.last_name") }}</label>
      <div class="controls">
        <input aria-required="true" class="form-control" id="last_name" name="last_name"
               required="" type="text" v-model="currentUser.last_name" v-validate="'required'">
      </div>
    </div>
    <transition name="slide-fade">
      <label class="error" for="last_name" id="last_name-error" v-show="errors.has('last_name')">
        {{ errors.first('last_name') }}
      </label>
    </transition>

    <div class="form-group form-group-default required">
      <label>{{ $t("models.user.first_name") }}</label>
      <div class="controls">
        <input aria-required="true" class="form-control" id="first_name" name="first_name"
               required="" type="text" v-model="currentUser.first_name" v-validate="'required'">
      </div>
    </div>
    <transition name="slide-fade">
      <label class="error" for="first_name" id="first_name-error" v-show="errors.has('first_name')">
        {{ errors.first('first_name') }}
      </label>
    </transition>

    <div class="form-group form-group-default required">
      <label>{{ $t("models.user.email") }}</label>
      <div class="controls">
        <input aria-required="true" class="form-control" id="email" name="email"
               required="" type="text" v-model="currentUser.email" v-validate="emailRules">
      </div>
    </div>
    <transition name="slide-fade">
      <label class="error" for="email" id="email-error" v-show="errors.has('email')">
        {{ errors.first('email') }}
      </label>
    </transition>

    <div class="form-group form-group-default required">
      <label>{{ $t("models.user.mobile_phone") }}</label>
      <div class="controls">
        <input aria-required="true" class="form-control" id="phone" name="mobile_phone"
               required=""
               type="tel" v-model="currentUser.phone_display" v-validate="'required|phone'">
      </div>
    </div>
    <transition name="slide-fade">
      <label class="error" for="phone" id="phone-error" v-show="errors.has('mobile_phone')">
        {{ errors.first('mobile_phone') }}
      </label>
    </transition>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    name: "CommonValidationForm",
    props: ['currentUser'],
    inject: ['$validator'],
    data() {
      return {
        initialEmail: null,
      }
    },
    computed: {
      ...mapGetters({
        serverErrors: 'users/errors',
        hasErrors: 'users/hasErrors'
      }),
      emailRules() {
        return `required|email|email-available:${this.initialEmail}`
      }
    },
    created() {
      this.initialEmail = this.currentUser.email
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/candidate/CommonValidationForm.vue